import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class ServiceGroupService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'ServiceGroup/';
  // fetch all ServiceGroup in the database
  allServiceGroup(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getServiceGroup(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getServiceGroupByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postServiceGroup(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteServiceGroup(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateServiceGroup(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
